export { StrongCache } from "./strong.js";
export { WeakCache } from "./weak.js";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@wry/caches/lib/index.js
// module id = 434
// module chunks = 11